import { Injectable } from '@angular/core';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { Observable } from 'rxjs';
import { ISSPCategory } from 'src/app/model/claims/ISSPCategoryMapping';
import { HttpClient } from '@angular/common/http';
import { IBrand } from 'src/app/model/claims/IBrand';
import { IClaimFile } from 'src/app/model/claims/IClaimFile';
import { IClaimFileResponse } from 'src/app/model/claims/IClaimFileResponse';
import { IDeviceType } from 'src/app/model/claims/IDeviceType';
import { ICategory } from 'src/app/model/device-inventory/ICategory';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private httpClient: HttpClient
  ) { }

  loadSSPMapping(): Observable<ISSPCategory[]> {
    return this.httpClient.get<ISSPCategory[]>(`${this.preInitSettingsService.getSettings().sspCategoryMapFile}`);
  }

  getBrandsList(query: string, totalCount = 10, isElita = false): Observable<IBrand[]> {
    return this.httpClient.get<IBrand[]>(`${this.preInitSettingsService.getSettings().middleWare.middlewareUrl}${this.preInitSettingsService.getSettings().middleWare.accountPath}brandlist?brand=${query}&count=${totalCount}&isElitaActive=${isElita}`);
  }

  getDeviceTypesList(dealerCode: string, masterCertificateNumber: string, coverageTypeCode: string): Observable<IDeviceType[]> {
    return this.httpClient.get<IDeviceType[]>(`${this.preInitSettingsService.getSettings().middleWare.middlewareUrl}${this.preInitSettingsService.getSettings().middleWare.accountPath}devicetypelist?dealerCode=${dealerCode}&masterCertificateNumber=${masterCertificateNumber}&coverageTypeCode=${coverageTypeCode}`);
  }

  postClaim(fileaClaimLinkUrl: string, contractId: string, category: string, code: string, brand: string, model: string): Observable<IClaimFileResponse> {
    const body: IClaimFile = {
      fileaClaimLinkUrl,
      policyNumber: contractId,
      product: {
        category,
        code,
        brand,
        model
      }
    };

    return this.httpClient.post<IClaimFileResponse>(`${this.preInitSettingsService.getSettings().middleWare.middlewareUrl}${this.preInitSettingsService.getSettings().middleWare.accountPath}claimlink`, body);
  }

  // This method (and the corresponding json file) are used to add extra categories to the main category dropdown in Claims.
  // This is a workaround, and should be improved as soon as possible.
  getExtraCategories(): Observable<ICategory[]> {
    return this.httpClient.get<ICategory[]>(`/assets/config/extra.categories.json`);
  }
}
